import { Tabs, Tab } from "@mui/material";
import { Default_Text_Color } from "../../constants/constants";
import { AFP, Box, CustomBackdrop, CustomDataGrid, CustomTableView, DataGrid, dayjs, GridColDef, TextField, Typography, useApi, useEffect, useState } from "../../utils/globalImports";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BuildIcon from "@mui/icons-material/Build";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { ProjectProposalBillings } from "../../interfaces/proposalInterface";

const tabStyle = {
  textTransform: "none",
  minHeight: "48px",
  height: "48px",
  px: 4,
  borderRadius: "25px",
  fontSize: "16px",
  fontWeight: 500,
  backgroundColor: "#ffffff",
  color: "#555",
  border: "1px solid #e0e0e0",

  "&:hover": {
    backgroundColor: "#f1f7ff",
  },

  "&.Mui-selected": {
    backgroundColor: "#1976d2",
    color: "#fff",
    border: "1px solid #1976d2",
  },
};
const wipConfig: GridColDef<any>[] = [
    {
  field: "dateAccured",
  headerName: "Date Accured",
  flex: 1,
  align: "center",
  headerAlign: "center",
  renderCell: (params) =>
    params.value
      ? dayjs(params.value).format("DD/MM/YYYY")
      : "",
},
  {
    field: "feestageNumber",
    headerName: "Fee Stage",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "description",
    headerName: "Fee Stage Description",
    flex: 2,
    align: "left", // Description usually looks better left-aligned
    headerAlign: "center",
  },
  {
    field: "wipBalance",
    headerName: "WIP Balance",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "wipAccrual",
    headerName: "WIP Accrued",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "wipRelease",
    headerName: "WIP Released",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "wipReason",
    headerName: "WIP Notes",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
];

const prebillConfig: GridColDef<any>[] = [
    {
  field: "dateAccured",
  headerName: "Date Accured",
  flex: 1,
  align: "center",
  headerAlign: "center",
  renderCell: (params) =>
    params.value
      ? dayjs(params.value).format("DD/MM/YYYY")
      : "",
},
  {
    field: "feestageNumber",
    headerName: "Fee Stage",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "description",
    headerName: "Fee Stage Description",
    flex: 2,
    align: "left",
    headerAlign: "center",
  },
  {
    field: "prebillBalance",
    headerName: "Prebill Balance",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "prebillAccrual",
    headerName: "Prebill Accrued",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "prebillRelease",
    headerName: "Prebill Released",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "prebillReason",
    headerName: "Prebill Notes",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
];

const afpConfig: GridColDef<any>[] = [
   {
  field: "dateAccured",
  headerName: "Date Accured",
  flex: 1,
  align: "center",
  headerAlign: "center",
  renderCell: (params) =>
    params.value
      ? dayjs(params.value).format("DD/MM/YYYY")
      : "",
},
  {
    field: "feestageNumber",
    headerName: "Fee Stage",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "description",
    headerName: "Fee Stage Description",
    flex: 2,
    align: "left",
    headerAlign: "center",
  },
  {
    field: "afpBalance",
    headerName: "AFP Balance",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "afpAccrual",
    headerName: "AFP Accrued",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
  {
    field: "afpRelease",
    headerName: "AFP Released",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",

  },
  {
    field: "afpNumber",
    headerName: "AFP Number",
    flex: 1,
    align: "center",
    headerAlign: "center",
    type: "number",
  },
];
interface WIPProps {
  proposalId?: number
}

const ProposalWIP: React.FC<WIPProps> = ({proposalId}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [data,setData]=useState<ProjectProposalBillings| null>(null);

  const {execute,loading}=useApi()
   const fetchBillings=async()=>{
    try{
       const {data}=await execute<ProjectProposalBillings>("get",`Proposal/ProposalBillings/${proposalId}`);
       setData(data);
    }
      catch{
          console.error()
      }
      
   }
   const getCurrentConfig = () => {
  switch (tabIndex) {
    case 0:
      return wipConfig;
    case 1:
      return afpConfig;
    case 2:
      return prebillConfig;
    default:
      return wipConfig;
  }
};
     const getCurrentData = () => {
  if (!data) return [];

  switch (tabIndex) {
    case 0:
      return data.wip;
    case 1:
      return data.afp;
    case 2:
      return data.prebill;
    default:
      return [];
  }
};
   useEffect(()=>{
    fetchBillings();
   },[])
 return (
    <>
    <Box
    sx={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
    }}
    >
  <Tabs
    value={tabIndex}
    onChange={(e, newValue) => setTabIndex(newValue)}
    variant="scrollable"
    scrollButtons="auto"
    TabIndicatorProps={{ style: { display: "none" } }}
    sx={{
      minHeight: "auto",
      "& .MuiTabs-flexContainer": {
        gap: 1,
      },
    }}
  >
    <Tab
      label="WIP"
      icon={<BuildIcon fontSize="small" />}
      iconPosition="start"
      sx={tabStyle}
    />
    <Tab
      label="AFP"
      icon={<AccountBalanceIcon fontSize="small" />}
      iconPosition="start"
      sx={tabStyle}
    />
    <Tab
      label="Pre Billing"
      icon={<RequestQuoteIcon fontSize="small" />}
      iconPosition="start"
      sx={tabStyle}
    />
  </Tabs>
</Box>
<Box sx={{ mt: 2, width: "100%" }}>
  <CustomDataGrid
  rows={getCurrentData()}
  columns={getCurrentConfig()}
  customMessage={`No Data Found`}
/>
</Box>
<CustomBackdrop open={loading} />
     </>
    
  );
};

export default ProposalWIP;